import { createMedium as e, createSidecarMedium as u } from "../../../use-sidecar/dist/es2015/medium.js";
var c = e({}, function(r) {
  var t = r.target, a = r.currentTarget;
  return {
    target: t,
    currentTarget: a
  };
}), d = e(), i = e(), n = u({
  async: !0,
  ssr: typeof document < "u"
});
export {
  d as mediumBlur,
  i as mediumEffect,
  c as mediumFocus,
  n as mediumSidecar
};
